// Each page is downloaded only when it is first opened, so the app starts faster.
import { lazy, type ComponentType } from 'react';

const KEY = 'sc-chunk-reload';

/**
 * Like React.lazy, but if a page file can't be loaded (usually because a newer version went live while the tab was
 * open), reload the app once to get the new version instead of showing a broken page.
 */
export function lazyPage<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const m = await load();
      try { sessionStorage.removeItem(KEY); } catch { /* storage may be blocked */ }
      return m;
    } catch (e) {
      let reloaded = false;
      try { reloaded = sessionStorage.getItem(KEY) === '1'; sessionStorage.setItem(KEY, '1'); } catch { /* ignore */ }
      if (!reloaded) { window.location.reload(); return new Promise<{ default: T }>(() => undefined); }
      throw e;
    }
  });
}
